import { StatLine } from "@/types/stats.d";

export function unit(stat: StatLine): string {
  if (stat.label === 'surgelés') {
    return 'commandes';
  }
  return stat.unit;
}
